import React from 'react';
import { Leaf, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { media } from '../data/media';
import { useLanguage } from '../contexts/LanguageContext';
export function IngredientsSection() {
  const {
    t
  } = useLanguage();
  return <section id="ingredients" className="scroll-mt-32 bg-creme-dark py-24 md:py-32" data-id="element-124" data-mp="ckut7vjum098">
      <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-125" data-mp="hjfwy4yb722f">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-126" data-mp="2rx8dirdvz7g">
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="border border-or/40 p-3" data-id="element-127" data-mp="7joxrpyszyw0">
            <img src={media.cacaoBeans} alt="Fèves de cacao torréfiées et pastilles de couverture" className="aspect-[4/3] w-full object-cover" data-id="element-128" data-mp="3fz8syuj1brdp" />
          </motion.div>

          <div data-id="element-129" data-mp="hdectd33e8pp">
            <span className="mb-4 block font-sans text-xs uppercase tracking-[0.22em] text-caramel" data-id="element-130" data-mp="hcusxqtvta91">
              {t.ingredients.eyebrow}
            </span>
            <h2 className="mb-6 font-serif text-3xl text-cacao-900 md:text-4xl" data-id="element-131" data-mp="qelx2r8rx90s">
              {t.ingredients.titleLead}{' '}
              <span className="italic text-or" data-id="element-132" data-mp="lfiztsz1c73d">
                {t.ingredients.titleAccent}
              </span>
            </h2>
            <p className="mb-8 font-sans font-light leading-relaxed text-cacao-700" data-id="element-133" data-mp="3tw4795c0qs4d">
              {t.ingredients.intro}
            </p>

            <p className="mb-10 flex items-center gap-3 border border-caramel/40 bg-creme px-5 py-4 font-serif text-lg italic text-cacao-900" data-id="element-134" data-mp="7fzvlb9chfwc">
              <Leaf size={18} strokeWidth={1.5} className="shrink-0 text-caramel" aria-hidden="true" data-id="element-135" data-mp="2ohumn7bnfbd" />
              {t.ingredients.freshNote}
            </p>

            <ul className="space-y-8" data-id="element-136" data-mp="3645qw6xpq6kd">
              {t.ingredients.items.map((item, index) => <motion.li key={item.title} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="border-l-2 border-caramel pl-5" data-id="element-137" data-mp="1a1108tiffube" data-mpi={index}>
                  <h3 className="mb-2 flex items-center gap-2 font-serif text-lg text-cacao-900" data-id="element-138" data-mp="r5ax32yrcrvx">
                    <Sparkles size={15} strokeWidth={1.5} className="text-or" aria-hidden="true" data-id="element-139" data-mp="w3vm068k7p52" />
                    {item.title}
                  </h3>
                  <p className="font-sans text-sm font-light leading-relaxed text-cacao-700" data-id="element-140" data-mp="2chm2ydks27w4">
                    {item.text}
                  </p>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}